module.exports = __webpack_public_path__ + "static/media/add-friends.4389027a.svg";